export default __webpack_public_path__ + "static/media/good.1437db7c.svg";